import React, {
    useState,
    useEffect,
    useCallback,
    useRef,
    useMemo
} from "react";
import {
    Button,
    Col,
    Modal,
    Row
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Form from "react-bootstrap/Form"
import Select from "react-select";
import { toast } from "react-toastify";
import { logout } from "../../../utils";
import { ThreeCircles } from "react-loader-spinner";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";

// css
import "./ExcelExportModal.css";
import { set } from "lodash";

export const ExcelExportModal = (props) => {
    const [bulkLinks, setBulkLinks] = useState(props.bulklinks);
    const [returnType, setReturnType] = useState("I");
    const [taxYear, setTaxYear] = useState("");
    const [clientName, setClientName] = useState("");
    const [clientID, setClientID] = useState("");

    const [activityId, setActivityId] = useState("");

    const [showReturnId, setShowReturnId] = useState(false);
    const [selectedReturnId, setSelectedReturnId] = useState("");
    const [showBars, setShowBars] = useState(false);
    const [showExcelBars, setExcelShowBars] = useState(false);

    const stopWords = ['and', '&', 'the', 'of', 'a'];  // Add more stopwords as needed

    const [returnIdOptions, setReturnIdOptions] = useState([

    ]);

    const [returnTypeOptions, setReturnTypeOptions] = useState([
        {
            value: "I",
            label: "1040 Individual",
            id: "individual",
        }, {
            value: "C",
            label: "1120 Corporation",
            id: "corporate",
        }, {
            value: "P",
            label: "1065 Partnership",
            id: "partnership",
        }, {
            value: "F",
            label: "1041 Fiduciary",
            id: "fiduciary",
        }, {
            value: "S",
            label: "1120S SCorporation",
            id: "s-corp",
        },
        {
            value: "K",
            label: "5500 Employee Benefit Plan",
            id: "5500-employee-benefit-plan",
        },
        {
            value: "K",
            label: "706 Estate & 709 Gift",
            id: "706-estate-709-gift",
        },
        {
            value: "K",
            label: "990 Exempt Organization",
            id: "990-exempt-organization",
        }
    ]);

    const onReturnTypeChange = (selectedOption) => {
        setReturnType(selectedOption.value);
    }

    const onSelectedReturnIdChange = (selectedOption) => {
        setSelectedReturnId(selectedOption.value);
    }

    const onTaxYearChange = (e) => {
        setTaxYear(e.target.value);
    }

    const onClientNameChange = (e) => {
        setClientName(e.target.value);
    }

    const onClientIDChange = (e) => {
        setClientID(e.target.value);
    }

    const onActivityIdChange = (e) => {
        setActivityId(e.target.value);

    }

    useEffect(() => {
        setBulkLinks(props.bulklinks)
    }, [props.bulklinks])

    function downloadURI(url, name) {
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        window.open(url)
        document.body.removeChild(link);
    }

    const getReturnIds = async () => {
        setShowBars(true);
        setReturnIdOptions([]); // Clear the current options

        if (returnType === "" || taxYear === "") {
            setShowBars(false);
            toast.error("Please select Return Type and Tax Year.", {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
            });
            return;
        }

        const url = `${process.env.REACT_APP_BASE_URI}/workflow/k1/get_return_ids/`;
        // alert("Return Ids are being generated. Please wait for the download to start.")
        const payload = {
            "ReturnType": returnType,
            "TaxYear": taxYear,
            "ClientName": clientName,
            "ClientId": clientID
        }
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
        }
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            },);
            const data = await response.json();
            // console.log("RETURN ID DATA: ", data);
            setShowBars(false);
            if (!response.ok) {
                if (response.status === 401) {
                    // Handle unauthorized error
                    logout();
                    alert("Session ended , Please login back");
                } else {
                    toast.error("Something went wrong.", {
                        position: "bottom-right",
                        autoClose: 2500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        className: "toastify-color-error",
                    });
                }
                return;
            }

            setShowReturnId(true);
            gridParamsMapper(data)
            const newOptions = data.data.map(id => ({
                value: id,
                label: id,
                id: id
            }));

            // Update the state with the new options
            // Use functional setState to ensure you're working with the latest state
            setReturnIdOptions(prevOptions => {
                // Combine current options with new ones, while filtering duplicates
                const combinedOptions = [...prevOptions, ...newOptions];
                // Remove duplicates based on `id`
                const uniqueOptions = combinedOptions.filter((option, index, self) =>
                    index === self.findIndex(o => o.id === option.id)
                );
                return uniqueOptions;
            });
            // console.log("RETURN ID OPTIONS: ", returnIdOptions)
        }
        catch {
            setShowBars(false);
            toast.error("Something went wrong.", {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
            });
        }

    }

    const importToTax = async () => {

        setExcelShowBars(true);
        let selectedFileIds = []
        let selectedReturnId = ""
        let selectedData = gridRef.current.api.selectionService.lastSelectedNode;
        if (selectedData === null) {
            // alert("Please select the task/s to retry.")
            toast.error("Please select a Return ID and retry.", {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-success",
            })
        } else {
            selectedReturnId = selectedData["data"]["ReturnID"]
        }

        for (let obj of props.selectedrows) {
            selectedFileIds.push(obj["ActiveKone"]["K1FileId"])
        }
        const payload = {
            "K1FileIds": selectedFileIds,
            "ReturnId": selectedReturnId,
            "ActivityId": activityId
        }
        console.log("PAYLOAD: ", payload);
        // return;
        const url = `${process.env.REACT_APP_BASE_URI}/workflow/k1/send_to_tax/`;

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
        }
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            },);
            const data = await response.json();
            // console.log("RETURN ID DATA: ", data);
            setShowBars(false);
            if (!response.ok) {
                if (response.status === 401) {
                    // Handle unauthorized error
                    logout();
                    alert("Session ended , Please login back");
                } else {
                    toast.error("Something went wrong.", {
                        position: "bottom-right",
                        autoClose: 2500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        className: "toastify-color-error",
                    });
                }
                setExcelShowBars(false);
                return;
            }
            if ( !data.success ){
                toast.error(data.message, {
                    position: "bottom-right",
                    autoClose: 2500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    className: "toastify-color-error",
                });
            }
            else{
                toast.success("K1 files imported into CCH Tax.", {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    className: "toastify-color-success",
                });
            }
        }
        catch {
            setShowBars(false);
            toast.error("Something went wrong.", {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
            });
        }

        console.log(payload);
        setExcelShowBars(false);
    }

    const downloadExcelFile = async () => {
        setExcelShowBars(true);
        let selectedFileIds = []
        let selectedReturnId = ""
        let selectedData = gridRef.current.api.selectionService.lastSelectedNode;
        if (selectedData === null) {
            // alert("Please select the task/s to retry.")
            toast.error("Please select a Return ID and retry.", {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-success",
            })
        } else {
            selectedReturnId = selectedData["data"]["ReturnID"]
        }

        for (let obj of props.selectedrows) {
            selectedFileIds.push(obj["ActiveKone"]["K1FileId"])
        }
        const payload = {
            "K1FileIds": selectedFileIds,
            "ReturnId": selectedReturnId
        }
        const apiUrl = `${process.env.REACT_APP_BASE_URI}/workflow/k1/export/bulk/`;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
        }

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            });
            setExcelShowBars(false);
            if (!response.ok) {
                throw new Error('Failed to download file');
            }

            // Get the file as a Blob
            const blob = await response.blob();

            // Create a link to download the file
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Set the file name (you can customize it based on your requirements)
            link.setAttribute('download', 'exported_data.xlsx');

            // Append the link to the body
            document.body.appendChild(link);

            // Trigger the download by programmatically clicking the link
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);

            toast.success("Please check your downloads.", {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-success",
            })

        } catch (error) {
            console.error('Error downloading the file:', error);
            toast.error("Error downloading the file.", {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
            })
        }
    }


    // Function to normalize and remove stopwords
    const normalizeName = (name) => {
        // Convert to lowercase and split by whitespace
        return name.toLowerCase()
            .split(/\s+/)  // Split by whitespace
            .filter(word => !stopWords.includes(word))  // Remove stopwords
            .join(' ')  // Join remaining words
            .trim();  // Trim any extra spaces
    };

    // Function to check if all partner names are the same
    const arePartnerNamesSame = (names) => {
        if (names.length === 0) return false;  // Edge case: empty array

        // Normalize the first name for comparison
        const normalizedFirstName = normalizeName(names[0]);

        // Check if every name in the array matches the normalized first name
        return names.every(name => normalizeName(name) === normalizedFirstName);
    };


    const checkPartnerNames = () => {
        let partnerNames = []
        for (let obj of props.selectedrows) {
            partnerNames.push(obj["ActiveKone"]["PartnerName"])
        }
        if (props.show && !arePartnerNamesSame(partnerNames)) {
            // console.error('Error downloading the file:', error);
            toast.error("Partner names you selected seams to be different. Because of that the import into tax will probably fail.", {
                position: "bottom-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
            })
        }

    }

    useEffect(() => {
        checkPartnerNames();
    }, [props.show])

    const CustomLoadingOverlay = (props) => {
        return (
            <div
                className="ag-overlay-loading-center"
                style={{ height: '9%' }}
            >

            </div>
        );
    };
    const CustomNoRowsOverlay = (props) => {
        return (
            <div
                className="ag-overlay-loading-center"
                style={{ height: '9%' }}
            >
                {/* <ThreeCircles
                height="100"
                width="100"
                color="#4fa94d"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="three-circles-rotating"
                outerCircleColor="var(--theme1_primary)"
                innerCircleColor="var(--theme1_secondary)"
                middleCircleColor="var(--theme1_tertiary)"
              /> */}
                {props.loadingMessage}
            </div>
        );
    };
    // declare default grid params
    const [rowData, setRowData] = useState([]);
    const [colDefs, setColDefs] = useState([]);

    /**
     * This function is used for formatting the default column names of the grid
     * @param {*} defaultName: Current name from API
     * @returns: Final column name
     */
    const GridColumnTitleRenderer = (defaultName) => {
        const splitWords = defaultName.split("_")
        for (let word in splitWords) {
            splitWords[word] = splitWords[word].charAt(0).toUpperCase() + splitWords[word].slice(1)
        }
        return splitWords.join(" ")
    }

    /**
     * This function takes the API response data and maps it to the grid params
     * @param {*} result: API response
     */
    const gridParamsMapper = (result) => {
        if (result.data.length != 0) {
            const keys = Object.keys(result.data[0]) // You need to change this based on API response format in every report
            let jsonColDefs = keys.map(key => {
                if (key === "ReturnID") {
                    return {
                        field: key, headerName: GridColumnTitleRenderer(key), checkboxSelection: true, pinned: "left"
                    }
                } else {
                    return {
                        field: key, headerName: GridColumnTitleRenderer(key)
                    }
                }
            });

            setColDefs(jsonColDefs)
        }
        setRowData(result.data);
    }
    let gridApi;
    const onGridReady = useCallback((params) => {
        gridApi = params.api;
        gridApi.closeToolPanel();
        const allColumnIds = params.columnApi.getAllColumns().map(col => col.getColId());
        params.columnApi.autoSizeColumns(allColumnIds); // Auto-size all columns
    }, []);
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%", marginTop: 20 }), []);
    const gridStyle = useMemo(() => ({ height: "400px", minHeight: "100%", width: "100%" }), []);
    const onFirstDataRendered = useCallback((params) => {
        // Get all the column IDs
        const allColumnIds = params.columnApi.getAllColumns().map(col => col.getId());

        // Auto-size the columns
        params.columnApi.autoSizeColumns(allColumnIds);
    }, []);
    const defaultColDef = useMemo(
        () => ({
            sortable: true,
            filter: true,
            resizable: true,
            animateRows: true,
        }),
        []
    );

    const loadingOverlayComponent = useMemo(() => {
        return CustomLoadingOverlay;
    }, []);
    const loadingOverlayComponentParams = useMemo(() => {
        return {
            loadingMessage: "Loading your records",
        };
    }, []);
    const noRowsOverlayComponent = useMemo(() => {
        return CustomNoRowsOverlay;
    }, []);
    const noRowsOverlayComponentParams = useMemo(() => {
        return {
            loadingMessage: "No records found",

        };
    }, []);

    return (
        <Modal
            {...props}
            onHide={() => {
                props.onHide()
                setShowReturnId(false)
            }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            scrollable={false}
            className="select-returntype-custom-modal"
        >
            <Modal.Header closeButton>
                <h5> &nbsp;Please select the details to get return Id</h5>

            </Modal.Header>
            <Modal.Body>
                <Row className="no-gutter">
                    <Col md={6}>
                        <label>&nbsp;Return Type <span className="madatory">*</span></label>
                        <Select
                            onChange={onReturnTypeChange}
                            value={returnTypeOptions.find(option => option.value === returnType)}
                            // defaultValue={flowOptions[0]}
                            placeholder={<div>Select Return Type</div>}
                            options={returnTypeOptions}
                            className='custom-select '
                            classNamePrefix="react-select"
                        />
                    </Col>
                    <Col md={6}>
                        <label>Tax Year <span className="madatory">*</span></label>
                        <Form.Control
                            type="number"
                            onChange={onTaxYearChange}
                            value={taxYear}
                            className="form-control custom-input"
                            id=""
                            placeholder="Tax Year"
                        />
                    </Col>
                </Row>
                <Row className="no-gutter" style={{ marginTop: 10 }}>
                    <Col md={4}>

                        <label>&nbsp;Client Name <Icon.FunnelFill style={{ color: "var(--theme1_tertiary)", fontSize: 14, marginLeft: 5 }}></Icon.FunnelFill></label>
                        <Form.Control
                            type="text"
                            onChange={onClientNameChange}
                            value={clientName}
                            className="form-control custom-input"
                            id=""
                            placeholder="Client name"
                        />
                    </Col>
                    <Col md={4}>

                        <label>Client ID <Icon.FunnelFill style={{ color: "var(--theme1_tertiary)", fontSize: 14, marginLeft: 5 }}></Icon.FunnelFill></label>
                        <Form.Control
                            type="text"
                            onChange={onClientIDChange}
                            value={clientID}
                            className="form-control custom-input"
                            id=""
                            placeholder="Client ID"
                        />
                    </Col>
                    <Col md={4}>
                        <label>Activity ID </label>
                        <Form.Control
                            type="number"
                            onChange={onActivityIdChange}
                            value={activityId}
                            className="form-control custom-input"
                            id=""
                            placeholder="Activity ID"
                        />
                    </Col>

                    <Col md={12} style={{ marginTop: 10, marginBottom: 10 }}>
                        <div className="intent-buttons">
                            <Button className="intent-save flex-row-center-center" onClick={getReturnIds} disabled={showBars}>
                                {showBars ?
                                    <div>
                                        <ThreeCircles
                                            height="15"
                                            width="15"
                                            color="#fff"
                                            ariaLabel="bars-loading"
                                            showBars={true}
                                        />
                                    </div>
                                    : <Icon.ArrowDownLeftCircleFill />}
                                &nbsp;&nbsp;Get Return IDS
                            
                            </Button>

                            {showReturnId && <Button className="intent-save flex-row-center-center" onClick={importToTax} disabled={showExcelBars}>
                                {showExcelBars ?
                                    <div>
                                        <ThreeCircles
                                            height="15"
                                            width="15"
                                            color="#fff"
                                            ariaLabel="bars-loading"
                                            showBars={true}
                                        />
                                    </div>
                                    : <Icon.CurrencyDollar />
                                } &nbsp;Import to CCH Tax
                            </Button>}


                            {showReturnId && <Button className="intent-save flex-row-center-center" onClick={downloadExcelFile} disabled={showExcelBars}>
                                {showExcelBars ?
                                    <div>
                                        <ThreeCircles
                                            height="15"
                                            width="15"
                                            color="#fff"
                                            ariaLabel="bars-loading"
                                            showBars={true}
                                        />
                                    </div>
                                    : <Icon.FileEarmarkSpreadsheetFill />
                                } &nbsp;Get Excel File
                            </Button>}
                            {/* <Button className="intent-skip" onClick={() => props.onHide()}> Leave </Button> */}

                        </div>
                    </Col>
                    <Col md={12}>
                        {
                            showReturnId &&
                            // <div className="return-ids-select">
                            //     <label>&nbsp;Return ID <span className="madatory">*</span></label>
                            //     <Select
                            //         onChange={onSelectedReturnIdChange}
                            //         value={returnIdOptions.find(option => option.value === selectedReturnId)}
                            //         // defaultValue={flowOptions[0]}
                            //         placeholder={<div>Select Return Id</div>}
                            //         options={returnIdOptions}
                            //         className='custom-select'
                            //         classNamePrefix="react-select"
                            //     />
                            // </div>
                            <div className="ag-theme-balham" style={gridStyle}>
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={rowData}
                                    columnDefs={colDefs}
                                    defaultColDef={defaultColDef}
                                    onGridReady={onGridReady}
                                    alwaysShowHorizontalScroll={false}
                                    alwaysShowVerticalScroll={false}
                                    onFirstDataRendered={onFirstDataRendered}
                                    pagination={true}
                                    loadingOverlayComponent={loadingOverlayComponent}
                                    loadingOverlayComponentParams={loadingOverlayComponentParams}
                                    noRowsOverlayComponent={noRowsOverlayComponent}
                                    noRowsOverlayComponentParams={noRowsOverlayComponentParams}
                                />
                            </div>
                        }
                    </Col>

                </Row>
            </Modal.Body>
        </Modal>
    )
}